import { Amplify } from '@aws-amplify/core';
import { Auth } from '@aws-amplify/auth';
import { customersApi } from 'api/bestpark/customers';
import { eraseCookie } from './cookie-helper';

Amplify.configure({
  Auth: {
    authenticationFlowType: 'CUSTOM_AUTH',
    userPoolId: process.env.REACT_APP_BESTCAMP_COGNITO_USER_POOL,
    userPoolWebClientId: process.env.REACT_APP_BESTCAMP_COGNITO_WEBCLIENT_ID,
  },
});

export interface AuthSession {
  userSession: any;
  accessToken?: string;
  userInfo?: Customer;
  cognitoSession?: any;
}

export const getCurrentUserToken = async (): Promise<string> => {
  const session = await Auth.currentSession();
  return session.getAccessToken().getJwtToken();
};

export const checkAuthToken = async (): Promise<string> => {
  let authToken: string;

  try {
    authToken = await getCurrentUserToken();
  } catch {
    authToken = '';
  }

  return authToken;
};

export const getCurrentSession = async (
  cognitoSession?: any,
): Promise<AuthSession> => {
  try {
    const session: any = await Auth.currentSession();
    const accessToken: string = session.getAccessToken().getJwtToken();
    const headers = {
      Authorization: accessToken,
    };
    if (!cognitoSession) {
      const user: Customer = await customersApi.profile(headers);
      return {
        userSession: session,
        accessToken: accessToken,
        userInfo: user,
      };
    } else {
      return {
        userSession: session,
        accessToken: accessToken,
        cognitoSession: cognitoSession,
      };
    }
  } catch (error) {
    eraseCookie('bestcamp-user');
    await Auth.signOut();
    return { userSession: '' };
  }
};

export const getApiKeyHeader = (apiKey: string): Record<string, string> => ({
  'x-api-key': apiKey,
});
